import { render, staticRenderFns } from "./HandleOfferItemDuplication.vue?vue&type=template&id=7c2e6eb7&scoped=true"
import script from "./HandleOfferItemDuplication.vue?vue&type=script&lang=ts"
export * from "./HandleOfferItemDuplication.vue?vue&type=script&lang=ts"
import style0 from "./HandleOfferItemDuplication.vue?vue&type=style&index=0&id=7c2e6eb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e6eb7",
  null
  
)

export default component.exports